module.exports = __webpack_public_path__ + "img/TelaLogin.bb2ceddb.jpg";